import { render, staticRenderFns } from "./SfLoader.vue?vue&type=template&id=769da3d2&"
import script from "./SfLoader.vue?vue&type=script&lang=js&"
export * from "./SfLoader.vue?vue&type=script&lang=js&"
import style0 from "./SfLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports